import React from 'react';

const GoogleLogo = props => (
  <svg
    viewBox="0 0 50 50"
    strokeWidth={0}
    fill="#FFF"
    height={24}
    stroke="currentColor"
    strokeLinecap="round"
    width={24}
    {...props}
  >
    <path
      d="M45 1H5C2.8 1 1 2.8 1 5v40c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V5c0-2.2-1.8-4-4-4z"
      stroke="none"
    />
    <path
      d="M20.3 10.5c3.3-1.1 7-1.1 10.3.1 1.8.7 3.5 1.7 4.9 3.1L34 15.2 31.2 18c-.9-.9-2.1-1.6-3.3-1.9-1.4-.4-3-.5-4.5-.2-1.7.4-3.3 1.3-4.6 2.5-1 1-1.8 2.3-2.2 3.6-1.7-1.3-3.3-2.6-5-3.9 1.8-3.5 5-6.3 8.7-7.6z"
      fill="#EA4335"
      stroke="none"
    />
    <path
      d="M10.3 22c.3-1.3.7-2.6 1.3-3.9 1.7 1.3 3.3 2.6 5 3.9-.7 1.9-.7 4 0 6-1.7 1.3-3.3 2.6-5 3.9-1.5-3.1-2-6.6-1.3-9.9z"
      fill="#FBBC05"
      stroke="none"
    />
    <path
      d="M25.3 22.1h14.4c.5 2.7.4 5.5-.4 8.1-.7 2.4-2 4.6-3.9 6.4-1.6-1.3-3.2-2.5-4.9-3.8 1.6-1.1 2.7-2.8 3.1-4.7h-8.3v-6z"
      fill="#4285F4"
      stroke="none"
    />
    <path
      d="M11.6 31.9c1.7-1.3 3.3-2.6 5-3.9.6 1.9 1.9 3.6 3.5 4.7 1 .7 2.2 1.2 3.4 1.5 1.2.2 2.4.2 3.7 0 1.2-.2 2.4-.7 3.4-1.3 1.6 1.3 3.2 2.5 4.9 3.8-1.8 1.6-3.9 2.7-6.3 3.3-2.6.6-5.3.6-7.8-.1-2-.5-3.9-1.5-5.6-2.8-1.7-1.5-3.2-3.3-4.2-5.2z"
      fill="#34A853"
      stroke="none"
    />
  </svg>
);

export default GoogleLogo;
